import { Box, Card, CardActions, Paper, Stack, Typography, useMediaQuery, useTheme } from '@mui/material'
import React from 'react'
import CropFreeIcon from '@mui/icons-material/CropFree';
import SettingsIcon from '@mui/icons-material/Settings';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import CloudIcon from '@mui/icons-material/Cloud';
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import ThermostatIcon from '@mui/icons-material/Thermostat';
import WaterDropIcon from '@mui/icons-material/WaterDrop';
import AutorenewIcon from '@mui/icons-material/Autorenew';
function FilterStrip({ title, ValueOf1, ValueOf2, onChangeValueOf1, onChangeValueOf2, onFullScreen, onRefreshData }) {
    // const { getGridLoadData, getInverterChartData } = useContext(InverterContext)
    const { palette, breakpoints, spacing } = useTheme()
    const lgs = useMediaQuery(breakpoints.down('lg'))

    const styles = {
        IconStyle: {
            color: 'primary.main',
            fontSize: '0.9rem',
            cursor: 'pointer'
        }
    }
    return (
        <Card>
            <CardActions sx={{ justifyContent: 'space-between', alignItems: "center" }}>
                <Typography variant='body1'>{title}</Typography>
                <Stack columnGap={spacing(1)} direction={'row'} justifyContent={'center'} alignItems={'center'}>
                    <CalendarMonthIcon sx={styles.IconStyle} />
                    <input type='date' value={ValueOf1} className='searchField' onChange={onChangeValueOf1} name='startDate' />
                    <Typography variant='body1' >To</Typography>
                    <input type='date' value={ValueOf2} className='searchField' onChange={onChangeValueOf2} name='endDate' />
                    <AutorenewIcon onClick={onRefreshData} sx={[styles.IconStyle]} />
                </Stack>
                <Stack direction={'row'} columnGap={spacing(1)} alignItems={'center'}>
                    <FullscreenIcon sx={styles.IconStyle} onClick={onFullScreen} color='primary' />
                    <SettingsIcon sx={styles.IconStyle} />
                </Stack>
            </CardActions>
        </Card>
    )
}

export default FilterStrip
